@if (isLoading) {
<div class="progress" style="position: relative">
  <div class="progress-bar indeterminate"></div>
</div>
}


<ngx-spinner bdColor="rgba(255,255,255,0.65)" [fullScreen]="true" type="none">

  <div class="custom-loader">
    <div class="loader-ring"></div>
    <div class="loader-content">
      <h6>{{ spinnerText || 'Loading...' }}</h6>
      <small>Please wait a moment</small>
    </div>
  </div>

</ngx-spinner>


<app-toast-control style="position: absolute; bottom: 5px; right: 5px; z-index:99999" aria-live="polite"
  aria-atomic="true"></app-toast-control>

<ng-template #updateAvailableModal aria-modal="true" let-modal>
  <app-update-available-control></app-update-available-control>
</ng-template>

@if (!isAppLoading) {
<div style="overflow-x: auto; height: 100%;">
  <router-outlet></router-outlet>

</div>
}